import { useState, useEffect } from "react";
import { useHttpClient } from "../../../../../../shared/hooks/http-hook";
import { useLoading } from "../../../../../../shared/context/LoadingContext";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import "./RelatorioExtratoCliente.scss";
import toast from "react-hot-toast";

function RelatorioExtratoCliente({ dadosClinica, auth, showExtrato }) {
  const { startLoading, stopLoading } = useLoading();
  const { sendRequest } = useHttpClient();

  const [clientes, setClientes] = useState([]);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [datas, setDatas] = useState({
    dataInicial: "",
    dataFinal: "",
  });

  // Buscar clientes ao montar o componente
  useEffect(() => {
    const fetchClientes = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/clientes/nomeid/${dadosClinica._id}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );

        setClientes(responseData.clientes || []);
      } catch (err) {
        console.error("Erro ao buscar clientes:", err);
      }
    };

    fetchClientes();
  }, [dadosClinica._id, auth.token, sendRequest]);

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setDatas((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const gerarExtratoHandler = async () => {
    // Validações
    if (!clienteSelecionado) {
      toast.error("Por favor, selecione um cliente");
      return;
    }

    if (!datas.dataInicial || !datas.dataFinal) {
      toast.error("Por favor, preencha as datas inicial e final");
      return;
    }

    if (new Date(datas.dataInicial) > new Date(datas.dataFinal)) {
      toast.error("Data inicial não pode ser maior que data final");
      return;
    }

    startLoading();
    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/getExtratoCliente/${clienteSelecionado._id}`,
        "POST",
        JSON.stringify({
          startDate: datas.dataInicial,
          endDate: datas.dataFinal,
          clinicaId: dadosClinica._id,
        }),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        }
      );

      // Chamar função para mostrar PDF
      showExtrato({
        show: true,
        ...responseData,
      });
    } catch (err) {
      console.error("Erro ao gerar extrato:", err);
      toast.error("Erro ao gerar extrato do cliente");
    } finally {
      stopLoading();
    }
  };

  const limparFormulario = () => {
    setClienteSelecionado(null);
    setDatas({
      dataInicial: "",
      dataFinal: "",
    });
  };

  return (
    <div className="relatorio-extrato-cliente">
      <div className="relatorio-extrato-form">
        <h3>Gerar Extrato do Cliente</h3>
        <p className="descricao">
          Selecione um cliente e o período para gerar o extrato financeiro
        </p>

        <div className="form-grid">
          {/* Autocomplete de Cliente */}
          <div className="form-item full-width">
            <label>Cliente *</label>
            <Autocomplete
              options={clientes}
              getOptionLabel={(option) => option.nome || ""}
              value={clienteSelecionado}
              onChange={(event, newValue) => {
                setClienteSelecionado(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Pesquisar cliente..."
                  variant="outlined"
                  size="small"
                />
              )}
              noOptionsText="Nenhum cliente encontrado"
              className="autocomplete-clientes"
            />
            {clienteSelecionado && (
              <div className="cliente-info">
                <span>NIF: {clienteSelecionado.nif || "-"}</span>
                <span>Contacto: {clienteSelecionado.contacto || "-"}</span>
              </div>
            )}
          </div>

          {/* Data Inicial */}
          <div className="form-item">
            <label>Data Inicial *</label>
            <input
              type="date"
              name="dataInicial"
              value={datas.dataInicial}
              onChange={handleDateChange}
              required
            />
          </div>

          {/* Data Final */}
          <div className="form-item">
            <label>Data Final *</label>
            <input
              type="date"
              name="dataFinal"
              value={datas.dataFinal}
              onChange={handleDateChange}
              required
            />
          </div>
        </div>

        {/* Botões de Ação */}
        <div className="form-acoes">
          <button
            className="btn-gerar"
            onClick={gerarExtratoHandler}
            disabled={
              !clienteSelecionado || !datas.dataInicial || !datas.dataFinal
            }
          >
            Gerar Extrato
          </button>
          <button className="btn-limpar" onClick={limparFormulario}>
            Limpar
          </button>
        </div>

        {/* Informações Adicionais */}
        <div className="info-box">
          <h4>ℹ️ Informações</h4>
          <ul>
            <li>
              O extrato incluirá todas as parcelas e entradas do período
              selecionado
            </li>
            <li>Parcelas pagas serão ordenadas por data de pagamento</li>
            <li>Parcelas pendentes serão ordenadas por data de vencimento</li>
            <li>
              O PDF será gerado automaticamente após clicar em "Gerar Extrato"
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default RelatorioExtratoCliente;
